import {
  object,
  record,
  string,
  number,
  nullable,
  withFailureHandler
} from 'common/json/extract';
import type { JSONValue } from 'common/api/apiClient';

// Conforms to the shape of errors returned by (at least) our v3 API
// endpoints, which in turn partially match the default JSON errors
// generated by Rails.
//
// The error itself is also marked as nullable, out of an abundance of
// caution, just in case the error response occurs elsewhere in the
// stack and no proper response body exists.
type ApiRequestFailureBody = {
  status: number;
  error: string;
  message: string | null;
} | null;

export const extractApiRequestFailureBody: (
  json: JSONValue
) => ApiRequestFailureBody = withFailureHandler(
  nullable(
    object(
      record({
        status: number,
        error: string,
        message: nullable(string)
      })
    )
  )
);
